import { render, staticRenderFns } from "./ReserveTransferProblemsReport.vue?vue&type=template&id=6b39a01c&"
import script from "./ReserveTransferProblemsReport.vue?vue&type=script&lang=js&"
export * from "./ReserveTransferProblemsReport.vue?vue&type=script&lang=js&"
import style0 from "./ReserveTransferProblemsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports